import { RadioGroup } from '@headlessui/react';
import { TranslationKey } from 'locales/fr';
import React, { ReactElement } from 'react';
import { Radio, Title } from 'components';
import { OptionContainer, OptionNameContainer } from './RadioSelect.style';

export type Options<T> = {
    name: TranslationKey;
    value: T;
    icon?: React.FunctionComponent;
};

export type RadioSelectProps<T> = {
    options: Options<T>[];
    onChange: (value: T) => void;
    selected?: T;
};

export const RadioSelect = <T,>({
    options,
    onChange,
    selected,
}: RadioSelectProps<T>): ReactElement => {
    return (
        <RadioGroup value={selected} onChange={onChange}>
            <div>
                {options.map((option) => {
                    const Icon = option.icon;
                    return (
                        <RadioGroup.Option key={option.name} value={option.value}>
                            {({ checked }) => (
                                <OptionContainer>
                                    <OptionNameContainer>
                                        {Icon && <Icon data-testid="icon" />}
                                        <Title text={option.name} type="normal" />
                                    </OptionNameContainer>
                                    <Radio checked={checked} />
                                </OptionContainer>
                            )}
                        </RadioGroup.Option>
                    );
                })}
            </div>
        </RadioGroup>
    );
};
